<template>
    <section>
        <register-attendance-tasks />
    </section>
</template>

<script>
	import { registerAttendanceTasks } from '@/components/ui-facilita/contracts'

	export default {
        name: 'contracts-register-attendance-tasks',
		components: {
			registerAttendanceTasks,
		},

		mounted() {
			const intervalId = setInterval(() => {
				const frameChat = document.querySelector('.octa-widget-v2')

				if (frameChat) {
					frameChat.style.display = 'none'
					// Parar o intervalo
					clearInterval(intervalId)
				}
			}, 10)
		},
	}
</script>
